var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page valign-wrapper",attrs:{"id":"settings-login"}},[_c('div',{staticClass:"wrapper"},[(_vm.$store.getters.platform !== 'browser')?_c('Login',{attrs:{"title":_vm.$t('SETTINGS.LOGIN')}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19e8bb55","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/Login.vue
// module id = null
// module chunks = 